import { createAction, props } from "@ngrx/store";

import { VtoConfiguration } from "@hermes/api-model-vto";

import { VtoPageType } from "../constants/vto.constant";
import {
    LocalizedVtoCategory,
    LocalizedVtoSubcategory,
} from "../model/localized-vto-category.model";
import { VtoCameraDimension } from "../reducers/vto-beauty-state";
import { VtoSdkError } from "../types/vto.types";

export const fetchVtoConfiguration = createAction(
    "[Vto-Beauty] Fetch of vto config",
);

export const fetchVtoConfigurationSuccess = createAction(
    "[Vto-Beauty] Fetch of vto config success",
    props<{ vtoConfig: VtoConfiguration }>(),
);

// UX states
export const userApprove = createAction("[Vto-Beauty] User approves VTO");

export const userDisapprove = createAction("[Vto-Beauty] User disapproves VTO");

export const openModal = createAction(
    "[Vto-Beauty] Open modal",
    props<{
        pageType: string;
    }>(),
);

export const closeModal = createAction("[Vto-Beauty] Close modal");

export const destroyModal = createAction("[Vto-Beauty] Destroy modal");

export const launchCamera = createAction("[Vto-Beauty] Launch camera");

export const changeScreenOrientation = createAction(
    "[Vto-Beauty] Change screen orientation",
);

export const updateCameraDimension = createAction(
    "[Vto-Beauty] Update camera dimension",
    props<{
        cameraDimension: VtoCameraDimension;
    }>(),
);

export const catchSdkError = createAction(
    "[Vto-Beauty] Sdk has an error",
    props<{
        sdkError: VtoSdkError;
    }>(),
);

export const onAir = createAction("[Vto-Beauty] Camera is on air");

export const fetchLocalizedVtoCategories = createAction(
    "[Vto-Beauty] Fetch of localized vto categories",
);

export const fetchLocalizedVtoCategoriesSuccess = createAction(
    "[Vto-Beauty] Fetch of localized vto categories success",
    props<{
        localizedVtoCategories: LocalizedVtoCategory[];
    }>(),
);

export const checkTimeOut = createAction("[Vto-Beauty] Check timeout");

export const updateSelectedSkuVariantOnDisplay = createAction(
    "[Vto-Beauty] update selected vto on display",
    props<{ currentVtoSku: string }>(),
);

export const updateActiveCategory = createAction(
    "[Vto-Beauty] update active category",
    props<{ vtoCategory: LocalizedVtoCategory }>(),
);

export const updateActiveSubcategory = createAction(
    "[Vto-Beauty] update active sub category",
    props<{ vtoSubcategory: LocalizedVtoSubcategory }>(),
);

export const learnMoreRedirect = createAction(
    "[Vto-Beauty] learn more event",
    props<{
        vtoCategory: LocalizedVtoCategory;
        vtoSubcategory: LocalizedVtoSubcategory;
    }>(),
);

export const updateTimeoutCameraId = createAction(
    "[Vto-Beauty] update timeout id",
    props<{ timeoutCameraId: ReturnType<typeof setTimeout> }>(),
);

export const updatePageType = createAction(
    "[Vto-Beauty] update page type",
    props<{
        pageType: VtoPageType;
    }>(),
);
